export default "__VITE_ASSET__e6307bab__"